import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { FormResponse } from '../../../lib/models/dto/form-response-dto';
import { Kfi } from '../models/kfi.model';
import { KfiFormService } from './kfi-form.service';

@Injectable()
export class KfiDataResolver implements Resolve<FormResponse<Kfi>> {
  constructor(private readonly kfiFormService: KfiFormService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<FormResponse<Kfi>> {
    if (this.isChildRoute(route)) {
      const kfiId = route.params['kfiId'];

      return this.kfiFormService.initialize(kfiId);
    }

    return EMPTY;
  }

  private isChildRoute(route: ActivatedRouteSnapshot): boolean {
    return route.params['kfiId'] !== 'undefined';
  }
}
